import request from "@/utils/request";
import Qs from "qs";

const api = {
  // 主任务分页查询(自定义)
  findPageAll: "/openapi/jWorkers/findPageAll",
  // 删除主任务(自定义)
  deletes: "/openapi/jWorkers/deletes",
  // 撤销任务（自定义）
  revokeWorker: "/openapi/jWorkers/revokeWorker",
  // 添加/修改项目（自定义）
  save: "/openapi/jWorkers/save",
  // 树形菜单接口（手机、后台自定义）
  trees: "/openapi/jTypes/trees",
  // 目录对应的人员接口（后台自定义）
  getUsersByCateId: "/openapi/jTypes/users",
  // 删除任务（任务开始后）
  deleteForce: "/openapi/jWorkers/deleteForce"
};

/**
 * 功能描述：主任务分页查询(自定义) <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 10:54 2021/1/27
 **/
export function findPageAll(parameter) {
  return request({
    url: api.findPageAll,
    method: "get",
    params: parameter
  });
}

/**
 * 功能描述：删除主任务(自定义) <br>
 * 〈〉
 * @Param 需要删除的任务id
 * @Return
 * @Author CHU
 * @Date 13:54 2021/1/27
 **/
export function deletes(parameter) {
  return request({
    url: api.deletes,
    method: "get",
    params: parameter
  });
}

/**
 * 功能描述：撤销任务（自定义） <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 14:05 2021/1/27
 **/
export function revokeWorker(parameter) {
  return request({
    url: api.revokeWorker,
    method: "get",
    params: parameter
  });
}

/**
 * 功能描述：删除开始以后的任务 <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 15:43 2021/3/26
 **/
export function deleteForce(parameter) {
  return request({
    url: api.deleteForce,
    method: "get",
    params: parameter
  });
}

/**
 * 功能描述：添加/修改项目（自定义） <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 14:40 2021/1/27
 **/
export function save(parameter) {
  return request({
    url: api.save,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

/**
 * 功能描述：树形菜单接口（手机、后台自定义） <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 8:59 2021/1/28
 **/
export function trees(parameter) {
  return request({
    url: api.trees,
    method: "get",
    params: parameter
  });
}

/**
 * 功能描述：目录对应的人员接口（后台自定义） <br>
 * 〈〉
 * @Param 资源目录id
 * @Return
 * @Author CHU
 * @Date 15:00 2021/3/1
 **/
export function getUsersByCateId(parameter) {
  return request({
    url: api.getUsersByCateId,
    method: "get",
    params: parameter
  });
}
